import { useEffect, useState } from "react";
import { connect, RootStateOrAny } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RouteComponentProps, useHistory } from "react-router";

import { Breadcrumb, Typography } from "antd";
import { EditOutlined, HomeOutlined } from "@ant-design/icons";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";

import {
  getSubmitted,
  getSubmittedUsingEdifecs,
} from "store/claim/batchReports/actions";
import { getHelpCenterLinks } from 'store/app/helpCenter/actions';

import SubmittedBatchClaimsTable from "components/Claims/SubmittedBatchClaimsTable";
import HelpCenterLink from 'components/Common/HelpCenterLink';

import styles from "./SubmittedBatchReports.module.scss";

const { Title } = Typography;

export type SubmittedBatchReportsPageProps = RouteComponentProps<any> & {
  getSubmitted(userId: string): any;
  getSubmittedUsingEdifecs(searchObject: Object): any;
  isSearching: boolean;
  isFetching: boolean;
  getHelpCenterLinks(companyId: string, page: string, type: string): any;
};

const SubmittedBatchReportsPage = (props: SubmittedBatchReportsPageProps) => {
  const history = useHistory();

  const [helpCenter, setHelpCenter] = useState<any>([]);

  useEffect(() => {
    getHelpCenterLinks();
  }, [])

  const getHelpCenterLinks = () => {
    props.getHelpCenterLinks(sessionStorage.getItem('ipaGroup')!, '/claims/batch/submitted', 'page')
      .then((response: any) => {
        setHelpCenter(response);
    })
    .catch((err: ErrorResponse) => {
      console.log(err?.response?.data?.Message);
    });
  }

  return (
    <div className={styles["submitted-batch-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4}>&nbsp;&nbsp;&nbsp;Submitted Batch Reports</Title>
      </div>

      <div>
        <Breadcrumb>
          <Breadcrumb.Item>
            <HomeOutlined onClick={() => history.push("/quality/overview")} />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <EditOutlined />
            <a href="#">Submitted Batch Claims</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        {helpCenter?.length > 0
          ? helpCenter.map((hc: any) => {
              return (
                <>
                  <div className={`row ${styles["help-center-link"]}`}>
                    <div className="col-md-24">
                      <HelpCenterLink
                        clickEventId={hc.ClickEventId}
                        linkName={hc.LinkName}
                        pagePath={hc.PagePath}
                        url={hc.Link}
                        companyId={hc.CompanyId}
                      />
                    </div>
                  </div>
                </>
              );
            })
          : null
        }
      </div>

      <div className={styles["content"]}>
        <SubmittedBatchClaimsTable
          getSubmitted={props.getSubmittedUsingEdifecs}
          isSearching={props.isSearching}
          isFetching={props.isFetching}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetching: store.rootReducer.claimBatchReports.isFetching,
  isSearching: store.rootReducer.claim.isSearching,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getSubmitted,
      getSubmittedUsingEdifecs,
      getHelpCenterLinks,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmittedBatchReportsPage);
